import { render } from "./ShopArrearsThree.vue?vue&type=template&id=884512b6&scoped=true"
import script from "./ShopArrearsThree.vue?vue&type=script&lang=js"
export * from "./ShopArrearsThree.vue?vue&type=script&lang=js"

import "./ShopArrearsThree.vue?vue&type=style&index=0&id=884512b6&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884512b6"]])

export default __exports__